import React from 'react';
import 'antd/dist/antd.css';
import { Typography } from 'antd';
import Video from './components/video';
import Sandbox_call from './components/sandbox_call';
// import Landing from './components/landing/landing;'

export const Sandbox = () => {
 return (
    <>
    <HeadingComponent />
    <Video />
    <br />
    <Sandbox_call />
    <br />
    <br />
    </>
  )
}


const HeadingComponent = () => {
    return (
        <Typography.Title level={2}>Test Case
        </Typography.Title>
    )
}


export default Sandbox; 